module.exports = __webpack_public_path__ + "static/img/contant_4.e43045b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_5/contant_4.jpg
// module id = 0ciP
// module chunks = 0